/**
 * JunctionIcon/index.js
 * desc: system icon for junction step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const JunctionIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="junction icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.junction.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg"><path d="M8.968.168h2.106v2.687h6.316c.336 0 .673.086.842.26L20 5.02l-1.768 1.863c-.169.173-.506.26-.842.26h-6.316v2.253h5.768c1.053 0 1.053 0 1.053.607v3.076c0 .248 0 .395-.072.481-.105.125-.359.125-.98.125h-5.77v8.146H8.969v-8.146H2.611c-.337 0-.674-.086-.843-.26L0 11.52l1.768-1.863c.169-.173.506-.26.843-.26h6.357V7.144h-5.81c-1.053 0-1.053 0-1.053-.607V3.461c0-.248 0-.395.072-.481.104-.125.359-.125.98-.125h5.811V.168z"/></svg>
    </IconButton>
);


export default JunctionIcon;
